import { ButtonProps, IconButton } from '@mui/material';
import { ChevronRightIcon } from '~/icons';
import { ICON_SIZE, PRIMARY_COLOR } from './styles';

const NextPaginationButton = (props: ButtonProps) => {
  return (
    <IconButton {...props} sx={{ padding: '4px 0px 4px 4px', color: PRIMARY_COLOR }}>
      <ChevronRightIcon style={{ width: ICON_SIZE, height: ICON_SIZE }} />
    </IconButton>
  );
};

export default NextPaginationButton;
